import React, { useState } from "react";
import "./FAQs.css";

const Instructions = () => {
  // const [activeIndex, setActiveIndex] = useState(null);

  // const FAQS = [
  //   {
  //     question: "How do I place my order?",
  //     answer: "To place your order, please follow the instructions provided in the portal and complete the order process."
  //   },
  //   {
  //     question: "What is the last date to place an order?",
  //     answer: "The uniform order must be placed by 30th May 2025 to ensure timely delivery and your child attends school in proper uniform as per the school dress code policy."
  //   },
  //   {
  //     question: "Can I choose the items?",
  //     answer: "No, parents cannot choose individual items. The Uniform bundle consists of mandatory requirements as per the school dress code policy."
  //   },
  //   {
  //     question: "Are all school uniform items available online?",
  //     answer: "Yes, all required school uniform items included in the bundle which are mandatory."
  //   },
  //   {
  //     question: "How do I know the correct size for my child?",
  //     answer: "Uniform measurements are preloaded after taking measurements at the school. In cases where measurements are unavailable, or if your child is a new admission, the size chart is displayed in the portal. Please refer to the size chart carefully before placing your order."
  //   },
  //   {
  //     question: "Can I change or cancel my order after placing it?",
  //     answer: "Orders once submitted cannot be cancelled."
  //   },
  //   {
  //     question: "How is my order delivered?",
  //     answer: "You can choose between home delivery (charged) or delivery at school (no charges), Delivery is available only within Hyderabad."
  //   },
  //   {
  //     question: "Do I need to be at home to receive my order?",
  //     answer: "Yes, you need to be at home. If you are not available, please authorize someone to receive the parcel on your behalf."
  //   },
  //   {
  //     question: "Can I return or exchange if the size doesn't fit? What is the process?",
  //     answer: "Parents are requested to double-check the size before placing the order. However, if there is a discrepancy in the size, please visit the school to return the parcel and collect the correct size in person. Kindly ensure that the item is unused, in original condition, and has the tag intact."
  //   },
  //   {
  //     question: "How long will it take to receive my order?",
  //     answer: "Orders are typically delivered within 5–7 working days. Delays, if any, will be communicated."
  //   },
  //   {
  //     question: "How can I track my order?",
  //     answer: "Once your order is shipped, a tracking link will be shared via email/ SMS."
  //   },
  //   {
  //     question: "Is it possible to order additional uniform items separately?",
  //     answer: "Yes, individual items can be ordered separately at a later date. The school will send a communication on the same."
  //   },
  //   {
  //     question: "What payment methods do you accept?",
  //     answer: "Payment is to be made via the uniform ordering portal only."
  //   },
  //   {
  //     question: "The amount has been debited but I have not received any order confirmation by email or SMS. What is to be done?",
  //     answer: "Please contact support@thathvauniforms.com, if the payment has not been returned to your account. Kindly note that queries will be addressed in 3 working days."
  //   }
  // ]; 
  
  // const toggleFAQ = (index) => {
  //   setActiveIndex(activeIndex === index ? null : index);
  // };

  // const splitFAQs = () => {
  //   const midpoint = Math.ceil(FAQS.length / 2);
  //   return {
  //     left: FAQS.slice(0, midpoint),
  //     right: FAQS.slice(midpoint)
  //   };
  // };

  // const { left, right } = splitFAQs();

  // const renderFAQs = (faqArray) => {
  //   return faqArray.map((faq, index) => {
  //     const actualIndex = faqArray === left ? index : index + left.length;
  //     const isActive = activeIndex === actualIndex;
      
  //     return (
  //       <div className="faq-item" key={actualIndex}>
  //         <div 
  //           className={`faq-question ${isActive ? 'active' : ''}`}
  //           onClick={() => toggleFAQ(actualIndex)}
  //         >
  //           <h5>{faq.question}</h5>
  //           <span className="faq-icon">{isActive ? '−' : '+'}</span>
  //         </div>
  //         <div className={`faq-answer ${isActive ? 'active' : ''}`}>
  //           <p>{faq.answer}</p>
  //         </div>
  //       </div>
  //     );
  //   });
  // };

  return (
    <div className="container my-5">
      <div className="faq-header mb-5">
        <h2 className="display-5 fw-bold text-primary">Important Guidelines</h2>
        {/* <p className="lead text-muted">Complete guidelines for The Gaudium School uniform ordering and dress code policy.</p> */}
      </div>

      <div className="row g-4 mb-5">
        {/* Bundle Overview */}
        <div className="col-12">
          <div className="card border-0 shadow-sm bg-light" style={{ borderRadius: '15px' }}>
            <div className="card-body p-4">
              <div className="d-flex align-items-center mb-3">
                <i className="bi bi-info-circle-fill text-primary fs-3 me-3"></i>
                <h4 className="mb-0 fw-bold">Uniform Bundle Overview</h4>
              </div>
              <p className="mb-0 fs-5">
                The Gaudium School Uniform bundle consists of the mandatory items required as per the school dress code policy, considering regular wear and tear as well as frequent washing cycles.
              </p>
            </div>
          </div>
        </div>

        {/* Guidelines */}
        <div className="col-md-6">
          <div className="card h-100 border-0 shadow-sm" style={{ borderRadius: '15px' }}>
            <div className="card-header bg-primary text-white border-0 py-3" style={{ borderRadius: '15px 15px 0 0' }}>
              <h5 className="mb-0"><i className="bi bi-mortarboard-fill me-2"></i>Formal / Regular Uniform</h5>
            </div>
            <div className="card-body">
              <ul className="list-group list-group-flush">
                <li className="list-group-item border-0 px-0"><i className="bi bi-check2-circle text-success me-2"></i>White Shirt</li>
                <li className="list-group-item border-0 px-0"><i className="bi bi-check2-circle text-success me-2"></i>Skirt / Formal Shorts / Formal Trousers</li>
                <li className="list-group-item border-0 px-0"><i className="bi bi-check2-circle text-success me-2"></i>Belt</li>
                <li className="list-group-item border-0 px-0"><i className="bi bi-check2-circle text-success me-2"></i>Knee Length Socks (Girls)</li>
                <li className="list-group-item border-0 px-0"><i className="bi bi-check2-circle text-success me-2"></i>Ankle Socks (Boys)</li>
                <li className="list-group-item border-0 px-0"><i className="bi bi-check2-circle text-success me-2"></i>Black Shoes</li>
                <li className="list-group-item border-0 px-0"><i className="bi bi-check2-circle text-success me-2"></i>Jacket issued by school</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card h-100 border-0 shadow-sm" style={{ borderRadius: '15px' }}>
            <div className="card-header bg-success text-white border-0 py-3" style={{ borderRadius: '15px 15px 0 0' }}>
              <h5 className="mb-0"><i className="bi bi-trophy-fill me-2"></i>Sports Uniform</h5>
            </div>
            <div className="card-body">
              <ul className="list-group list-group-flush">
                <li className="list-group-item border-0 px-0"><i className="bi bi-check2-circle text-success me-2"></i>Sports Tee</li>
                <li className="list-group-item border-0 px-0"><i className="bi bi-check2-circle text-success me-2"></i>Sports Shorts (Primary) / Track Pants (Middle & High School)</li>
                <li className="list-group-item border-0 px-0"><i className="bi bi-check2-circle text-success me-2"></i>Socks</li>
                <li className="list-group-item border-0 px-0"><i className="bi bi-check2-circle text-success me-2"></i>Black Shoes</li>
                <li className="list-group-item border-0 px-0"><i className="bi bi-check2-circle text-success me-2"></i>Jacket issued by school</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Dress Code Policy Alert */}
        <div className="col-12">
          <div className="alert alert-warning border-0 shadow-sm p-4" style={{ borderRadius: '15px' }}>
            <h5 className="fw-bold mb-3 text-dark"><i className="bi bi-exclamation-triangle-fill me-2 text-warning"></i>Mandatory Dress Code Policy</h5>
            <div className="row g-3">
              <div className="col-md-4">
                <div className="p-3 bg-white bg-opacity-50 rounded-3 h-100">
                  <h6 className="fw-bold">Skirt Length</h6>
                  <small>Girls’ skirts must be <b>knee-length</b> as per the school dress code policy. If the specified
size requirement is not met, parents will be asked to repurchase the skirt.</small>
                </div>
              </div>
              <div className="col-md-4">
                <div className="p-3 bg-white bg-opacity-50 rounded-3 h-100">
                  <h6 className="fw-bold">Formal Shirts</h6>
                  <small>Formal shirts must always be <b>tucked in</b>. Parents are requested to keep this in mind
while placing uniform orders. If the shirt cannot be tucked in due to size issues, the
school will require parents to repurchase the shirt to meet the dress code policy.</small>
                </div>
              </div>
              <div className="col-md-4">
                <div className="p-3 bg-white bg-opacity-50 rounded-3 h-100">
                  <h6 className="fw-bold">Sports Shoes</h6>
                  <small>Students are required to wear <b>black sports shoes with non-marking soles </b> as a mandatory part of the uniform..</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Important Info Grid */}
        <div className="col-md-3">
          <div className="card h-100 border-0 shadow-sm text-center p-3" style={{ borderRadius: '15px' }}>
            <div className="mb-2"><i className="bi bi-calendar-event text-danger fs-1"></i></div>
            <h6 className="fw-bold">Deadline</h6>
            {/* <p className="small text-muted mb-0">Uniform orders must be placed by <strong>May 20th, 2026</strong> for timely delivery and to make sure your child attends school in proper uniform as per the school dress code policy. Orders placed from <strong>May 26th, 2026 onwards</strong> will be delivered by <strong>mid-June 2026</strong></p> */}
            <p className="small text-muted mb-0">
              Uniform orders must be placed by <strong>15 October 2026</strong>, and all orders will be processed subject to stock availability.
            </p>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card h-100 border-0 shadow-sm text-center p-3" style={{ borderRadius: '15px' }}>
            <div className="mb-2"><i className="bi bi-aspect-ratio text-info fs-1"></i></div>
            <h6 className="fw-bold">Measurements</h6>
            <p className="small text-muted mb-0">Size charts vary for each item, for example formal shirt sizes differ from sports shirt sizes. Always check the product-specific chart before placing your order</p>
            <p className="small text-muted mb-0">Parents are requested to double-check the size before placing the order, as there will
be <strong>no exchange</strong><br></br>
Orders once submitted cannot be cancelled.
<br></br>
All measurements provided are for the readymade garment, not body measurements.

.</p>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card h-100 border-0 shadow-sm text-center p-3" style={{ borderRadius: '15px' }}>
            <div className="mb-2"><i className="bi bi-truck text-success fs-1"></i></div>
            <h6 className="fw-bold">Delivery</h6>
            <p className="small text-muted mb-0">
              Orders will be delivered in 10 working days to the address provided in the portal or given at the time of placing the order.
 Kindly note that deliveries will be made only within <strong>Hyderabad</strong>.
{/* Once your order is shipped, a tracking link will be shared via email/ SMS. */}
&nbsp; Once your order is shipped, the tracking link will be available in My Orders
</p>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card h-100 border-0 shadow-sm text-center p-3" style={{ borderRadius: '15px' }}>
            <div className="mb-2"><i className="bi bi-headset text-primary fs-1"></i></div>
            <h6 className="fw-bold">Support</h6>
            <p className="small text-muted mb-0">Contact <a href="mailto:support@thathvauniforms.com">support@thathvauniforms.com</a> for any queries.
Kindly note that queries will be addressed within 3 working days.</p>
          </div>
        </div>
      </div>

      {/* <div className="banner-container">
        <img src={bannerImage} alt="Thathva Washcare Instructions" className="banner-image" />
      </div>
      
      <div className="faq-header">
        <h2>Frequently Asked Questions</h2>
        <p>Find answers to common questions about ordering school uniforms</p>
      </div>
      
      <div className="faq-container">
        <div className="row">
          <div className="col-lg-6 col-md-12 mb-4 faq-column">
            {renderFAQs(left)}
          </div>
          <div className="col-lg-6 col-md-12 faq-column">
            {renderFAQs(right)}
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Instructions;
